module.exports = __webpack_public_path__ + "img/2kimportchoose.fecf6188.png";